import React from "react";
import {
  Grid,
  TextField,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider,
  IconButton,
  Dialog,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Box,
} from "@mui/material";
import "react-quill/dist/quill.snow.css";
import CloseIcon from "@mui/icons-material/Close";
import CustomTypography from "../../globalStyles/fonts";
import { disabledFieldSx } from "../../constants/fieldStyles";

const ArchiveOrderDetailsModal = ({ order, open, onClose }) => {
  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingRight: 8,
            paddingTop: 8,
          }}
        >
          <DialogTitle>{"Historical Order Details"}</DialogTitle>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </div>
        <Divider style={{ marginBottom: "10px" }} />
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <CustomTypography
                color="var(--text-heading)"
                fontSize="14px"
                fontWeight={400}
              >
                Order Id
              </CustomTypography>
              <TextField
                type="text"
                size="small"
                margin="dense"
                value={order?.order_id || ""}
                fullWidth
                InputProps={{ readOnly: true }}
                sx={disabledFieldSx}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTypography
                color="var(--text-heading)"
                fontSize="14px"
                fontWeight={400}
              >
                Date
              </CustomTypography>
              <TextField
                size="small"
                margin="dense"
                variant="outlined"
                type="text"
                fullWidth
                value={order?.order_date || ""}
                InputProps={{ readOnly: true }}
                sx={disabledFieldSx}
              />
            </Grid>
            {/* Remove single line item fields (item, sku, price, qty, size) */}
          </Grid>

          {/* Line Items Section */}
          <Divider style={{ margin: "24px 0 12px 0" }} />
          <Typography variant="h6" gutterBottom>
            Line Items
          </Typography>
          <Box sx={{ background: "#fafbfc", borderRadius: 2, p: 2 }}>
            {order?.line_items && order.line_items.length > 0 ? (
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>SKU</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Title</TableCell>
                    <TableCell>Variant</TableCell>
                    <TableCell>HS Code</TableCell>
                    <TableCell>Quantity</TableCell>
                    <TableCell>Price</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {order.line_items.map((item) => (
                    <TableRow key={item.id}>
                      <TableCell>{item.sku}</TableCell>
                      <TableCell>{item.name}</TableCell>
                      <TableCell>{item.title}</TableCell>
                      <TableCell>{item.variant_title}</TableCell>
                      <TableCell>{item.hs_code}</TableCell>
                      <TableCell>{item.quantity}</TableCell>
                      <TableCell>{item.price}</TableCell>
                    </TableRow>
                  ))}
                  {/* Optional: summary row */}
                  <TableRow>
                    <TableCell colSpan={6} align="right">
                      <b>Total</b>
                    </TableCell>
                    <TableCell>
                      <b>{order.total_line_items_price}</b>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            ) : (
              <Typography color="textSecondary">No line items</Typography>
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            onClick={onClose}
            variant="outlined"
            style={{ textTransform: "none" }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ArchiveOrderDetailsModal;
